import React from 'react';
import { useDispatch } from 'react-redux';
import { evalFunc } from '../../utils/helpers';
import { updateLayout } from './index';

export default function useUpdateSelectedDetails() {
  const dispatch = useDispatch();
  return React.useCallback(payload => dispatch(updateLayout(prev => ({ ...prev, selectedDetails: evalFunc(payload, prev.selectedDetails) }))), [dispatch]);
}
